module.exports = __webpack_public_path__ + "static/content_BG-bfa57e790840ca1cb075e1d000437a3e.png";